webpackJsonp([35783957827783],{

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(43);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(120);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/AIBC.d1b3f679.png";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SAF.05898136.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/YARA.33c99c8a.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ticSoundDemo.8b2d2735.png";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/typingGameDemo.88950f61.png";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(127);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ExperienceUnit = __webpack_require__(206);
	
	var _ExperienceUnit2 = _interopRequireDefault(_ExperienceUnit);
	
	var _SAF = __webpack_require__(479);
	
	var _SAF2 = _interopRequireDefault(_SAF);
	
	var _AIBC = __webpack_require__(478);
	
	var _AIBC2 = _interopRequireDefault(_AIBC);
	
	var _YARA = __webpack_require__(480);
	
	var _YARA2 = _interopRequireDefault(_YARA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceSection = function (_React$Component) {
	  _inherits(ExperienceSection, _React$Component);
	
	  function ExperienceSection() {
	    _classCallCheck(this, ExperienceSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ExperienceSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Experience' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _YARA2.default,
	          colour: '#FFFFFF',
	          title: 'Yara International, Digital Hub',
	          link: 'https://play.google.com/store/apps/details?id=com.yarafarmweather.farmweather',
	          timeperiod: '2019-Present',
	          subtitle: 'Collaborated on FarmWeather, a hyperlocal weather TWA app built for smallholder farmers thats leverages on IBM weather api.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _AIBC2.default,
	          colour: '#FFFFFF',
	          title: 'Actionable Insights Brewing Company',
	          link: 'https://antenn.ai',
	          timeperiod: '2018-2019',
	          subtitle: 'Collaborated on Antenn.ai, an AI powered political lobbying web app/PWA.'
	        }),
	        _react2.default.createElement(_ExperienceUnit2.default, {
	          logo: _SAF2.default,
	          colour: '#FFFFFF',
	          title: 'Singapore Armed Forces',
	          link: 'https://www.linkedin.com/in/abdulhakimsg/',
	          timeperiod: '2012-2018',
	          subtitle: 'Senior Faculty trainer in Specialist Cadet School.Platoon Sergeant in 3 Guards Battalion'
	        })
	      )
	    );
	  };
	
	  return ExperienceSection;
	}(_react2.default.Component);
	
	exports.default = ExperienceSection;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExperienceUnit = function (_Component) {
	  _inherits(ExperienceUnit, _Component);
	
	  function ExperienceUnit() {
	    _classCallCheck(this, ExperienceUnit);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ExperienceUnit.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'experience-unit col-xs-12 col-sm-6 col-md-4' },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link, target: '_blank' },
	        _react2.default.createElement('div', {
	          className: 'image',
	          style: {
	            backgroundImage: 'url(' + this.props.logo + ')',
	            backgroundColor: this.props.colour
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'time-period' },
	        this.props.timeperiod
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        this.props.subtitle
	      ),
	      _react2.default.createElement('div', { className: 'technologies' })
	    );
	  };
	
	  return ExperienceUnit;
	}(_react.Component);
	
	exports.default = ExperienceUnit;
	module.exports = exports['default'];

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectUnit = function (_Component) {
	  _inherits(ProjectUnit, _Component);
	
	  function ProjectUnit() {
	    _classCallCheck(this, ProjectUnit);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProjectUnit.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'experience-unit col-xs-12 col-sm-6 col-md-4' },
	      _react2.default.createElement(
	        'a',
	        { href: this.props.link, target: '_blank' },
	        _react2.default.createElement('div', {
	          className: 'image',
	          style: {
	            backgroundImage: 'url(' + this.props.logo + ')',
	            backgroundColor: this.props.colour
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'title bold' },
	        this.props.title,
	        '\u2003',
	        _react2.default.createElement(
	          'a',
	          { href: this.props.githubLink, target: '_blank' },
	          _react2.default.createElement('i', { className: 'fa fa-github fa-2x', id: 'githubIcon' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'time-period' },
	        this.props.timeperiod
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        this.props.subtitle
	      ),
	      _react2.default.createElement('div', { className: 'technologies' })
	    );
	  };
	
	  return ProjectUnit;
	}(_react.Component);
	
	exports.default = ProjectUnit;
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(127);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ProjectUnit = __webpack_require__(207);
	
	var _ProjectUnit2 = _interopRequireDefault(_ProjectUnit);
	
	var _typingGameDemo = __webpack_require__(484);
	
	var _typingGameDemo2 = _interopRequireDefault(_typingGameDemo);
	
	var _sgCarparkApp = __webpack_require__(482);
	
	var _sgCarparkApp2 = _interopRequireDefault(_sgCarparkApp);
	
	var _ticSoundDemo = __webpack_require__(483);
	
	var _ticSoundDemo2 = _interopRequireDefault(_ticSoundDemo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectsSection = function (_React$Component) {
	  _inherits(ProjectsSection, _React$Component);
	
	  function ProjectsSection() {
	    _classCallCheck(this, ProjectsSection);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectsSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Section2.default,
	      { title: 'Projects' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_ProjectUnit2.default, {
	          logo: _typingGameDemo2.default,
	          colour: '#FFC0CB',
	          title: 'Typing Game',
	          link: 'https://abdulhakimsg.github.io/Typing-Game/',
	          timeperiod: 'Sept 2018',
	          subtitle: 'A typing game built purely from vanillaJS',
	          githubLink: 'https://github.com/Abdulhakimsg/Typing-Game'
	        }),
	        _react2.default.createElement(_ProjectUnit2.default, {
	          logo: _sgCarparkApp2.default,
	          colour: '#DFB94C',
	          title: 'Carpark Finder',
	          link: 'https://sgcarpark-finder.herokuapp.com/',
	          timeperiod: 'October 2018',
	          subtitle: 'Carpark Finder app that leverages on LTA\'s Datamall API which is updated every minute.  Built using NodeJS , express and react-views.',
	          githubLink: 'https://github.com/Abdulhakimsg/sgcarpark_avail'
	        }),
	        _react2.default.createElement(_ProjectUnit2.default, {
	          logo: _ticSoundDemo2.default,
	          colour: '#000000',
	          title: 'TicSound',
	          link: 'http://ticsound.herokuapp.com/',
	          timeperiod: 'October 2018',
	          subtitle: 'Events Listing site.Built using Ruby on Rails, PostgreSQL and leverages on Google Maps API',
	          githubLink: 'https://github.com/Abdulhakimsg/ticsound'
	        })
	      )
	    );
	  };
	
	  return ProjectsSection;
	}(_react2.default.Component);
	
	exports.default = ProjectsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h6',
	        { className: 'bold' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section-units' },
	        this.props.children
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	module.exports = exports['default'];

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement(
	        'a',
	        { href: '../' },
	        _react2.default.createElement('div', { className: 'image' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subLink' },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://blog.abdulhakimsg.com', className: 'subLink' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'subLink' },
	            'BLOG'
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(366);
	
	__webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Links = function (_Component) {
	  _inherits(Links, _Component);
	
	  function Links() {
	    _classCallCheck(this, Links);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Links.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'links' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'icons-list' },
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/Abdulhakimsg', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-github ' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/abdulhakimsg/', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-linkedin ' })
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'icon' },
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:contact@abdulhakimsg.com', target: '_blank' },
	            _react2.default.createElement('i', { className: 'fa fa-envelope ' })
	          )
	        )
	      )
	    );
	  };
	
	  return Links;
	}(_react.Component);
	
	exports.default = Links;
	module.exports = exports['default'];

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExperienceSection = __webpack_require__(205);
	
	var _ExperienceSection2 = _interopRequireDefault(_ExperienceSection);
	
	var _ProjectsSection = __webpack_require__(208);
	
	var _ProjectsSection2 = _interopRequireDefault(_ProjectsSection);
	
	var _About = __webpack_require__(209);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Links = __webpack_require__(210);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'index' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Hi, I\'m ',
	        _react2.default.createElement(
	          'span',
	          { className: 'bold' },
	          'Hakim'
	        )
	      ),
	      _react2.default.createElement(
	        'h4',
	        { className: 'bold' },
	        'a software developer based in Singapore currently with Yara Digital Hub who is currently working on our FarmWeather Project. I am very passionate about the web and have professional experience with ReactJS, GatsbyJS, VueJS and Ruby on Rails.'
	      ),
	      _react2.default.createElement(_ExperienceSection2.default, null),
	      _react2.default.createElement(_ProjectsSection2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'aside' },
	      _react2.default.createElement(
	        'div',
	        { className: 'top' },
	        _react2.default.createElement(_About2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'bottom' },
	        _react2.default.createElement(_Links2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8b299901c8ecb502aacd.js